// const createDataAssistant = (data, files, driveFile) => {
//   let formData = new FormData();

//   formData.append("name", data.name);
//   formData.append("userId", data.userId);

//   // Удаляем useFiles из settings, чтобы не было дублирования
//   const settingsCopy = { ...data.settings };
//   delete settingsCopy.useFiles;
//   delete settingsCopy.useReminder;

//   for (const [key, value] of Object.entries(settingsCopy)) {
//     formData.append(key, value);
//   }

//   if (data.settings.useReminder) {
//     formData.append("useReminder", 1);
//   } else {
//     formData.append("useReminder", 0);
//   }

//   if (driveFile) {
//     formData.append("driveFile", driveFile);
//   }

//   if (files.length > 0) {
//     files.forEach((file, index) => {
//       if (file.id === undefined) {
//         formData.append("file" + (index + 1), file);
//       }
//     });
//     formData.append("useFiles", 1);
//   } else {
//     formData.append("useFiles", 0);
//   }

//   return formData;
// };

// export default createDataAssistant;

const createDataAssistant = (data, driveFile = null) => {
  const formData = new FormData();

  // Основные поля
  formData.append("name", data.name || "");
  formData.append("firstName", data.firstName || "");
  formData.append("companyDescription", data.companyDescription || "");
  formData.append("purpose", data.purpose || "");
  formData.append("answerLength", data.answerLength || "");
  formData.append("appeal", data.appeal || "");
  formData.append("communicationStyle", data.communicationStyle || "");
  formData.append("userId", data.userId || "");
  formData.append("responseDelay", data.responseDelay || "15");
  formData.append("splitMessage", data.splitMessage || false);

  // Массив collectedData (преобразуем в JSON-строку)
  if (Array.isArray(data.collectedData)) {
    formData.append("collectedData", JSON.stringify(data.collectedData));
  }

  // Массив faq
  if (Array.isArray(data.faq)) {
    formData.append("faq", JSON.stringify(data.faq));
  }

  // Массив actions
  if (Array.isArray(data.actions)) {
    formData.append("actions", JSON.stringify(data.actions));
  }

  // Настройки
  const settingsCopy = { ...data.settings };
  delete settingsCopy.useFiles;
  delete settingsCopy.useReminder;
  delete settingsCopy.files;

  for (const [key, value] of Object.entries(settingsCopy)) {
    formData.append(key, value);
  }

  // useReminder как 1/0
  formData.append("useReminder", data.settings.useReminder ? 1 : 0);
  formData.append("useFiles", data.settings.useFiles ? 1 : 0);

  // useFiles и файлы
  const filteredFiles = data.files.filter((file) => file.id === undefined);
  if (filteredFiles.length > 0) {
    filteredFiles.forEach((file, index) => {
      formData.append("file" + (index + 1), file);
    });
  }

  // driveFile
  if (driveFile) {
    formData.append("driveFile", driveFile);
  }

  return formData;
};

export default createDataAssistant;
